var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { DateTime } from 'luxon';
import { getTimeIntervalStr, formatDuration } from '@amzn/atoz-shiftapp-utilities';
export var useVTOAccepted = function (scheduleShift) {
    var _a;
    var vtoAcceptedLinesProps = (_a = scheduleShift === null || scheduleShift === void 0 ? void 0 : scheduleShift.acceptedVtoTimeRanges) === null || _a === void 0 ? void 0 : _a.map(function (vtoTimeRange) {
        var intervalStr = getTimeIntervalStr(DateTime.fromISO(vtoTimeRange.start), DateTime.fromISO(vtoTimeRange.end));
        var duration = DateTime.fromISO(vtoTimeRange.end).diff(DateTime.fromISO(vtoTimeRange.start), ['hours', 'minutes', 'seconds']);
        var durationStr = formatDuration(duration);
        return {
            intervalStr: intervalStr,
            durationStr: durationStr
        };
    });
    return !!(vtoAcceptedLinesProps === null || vtoAcceptedLinesProps === void 0 ? void 0 : vtoAcceptedLinesProps.length) ? vtoAcceptedLinesProps : null;
};
useVTOAccepted.fragments = {
    scheduleShift: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment UseVtoAccepted_ScheduleShift on ScheduleShift {\n            acceptedVtoTimeRanges {\n                start\n                end\n            }\n        }\n    "], ["\n        fragment UseVtoAccepted_ScheduleShift on ScheduleShift {\n            acceptedVtoTimeRanges {\n                start\n                end\n            }\n        }\n    "])))
};
var templateObject_1;
